import { useState } from 'react';
import { ToastType, showToastMessage } from '../../utils/ToastOptionCommon';
import Loader from '../../components/CommonComponents/Loader/Loader';
import axiosCall from '../../utils/axiosCall';
import SEO from '../../components/SEO/SEO';
import { Helmet } from 'react-helmet-async';

const initialInputData = {
  name: '',
  email: '',
  message: '',
};

export const isEmail = (email: string) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email.trim().toLowerCase());
};

export const ContactUs = () => {
  const [inputData, setInputData] = useState(initialInputData);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    // validate inputs
    if (
      inputData?.name?.trim()?.length === 0 ||
      inputData?.email?.trim()?.length === 0 ||
      inputData?.message?.trim()?.length === 0
    ) {
      return showToastMessage(
        'Please fill all required fileds',
        ToastType.Error
      );
    }
    if (inputData?.message?.length > 500) {
      return showToastMessage(
        'Your message is too long. Keep it below 500 charcters.',
        ToastType.Error
      );
    }
    if (!isEmail(inputData?.email)) {
      return showToastMessage('Please give a valid email id', ToastType.Error);
    }
    const url = '/usermessage/addMessage';

    const payload = {
      name: inputData?.name,
      email: inputData?.email,
      message: inputData?.message,
    };

    try {
      setIsLoading(true);

      const response = await axiosCall.post(url, payload);

      if (response.status === 200) {
        showToastMessage('Successfully sent your message', ToastType.Success);
      } else {
        showToastMessage(
          'Something wrong happend while sending your message',
          ToastType.Error
        );
      }
    } catch (error) {
      showToastMessage('Failed to submit your message', ToastType.Error);
      console.log(error);
    } finally {
      setIsLoading(() => false);
      setInputData(() => initialInputData);
    }
  };

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setInputData((prevData) => ({
      ...prevData,
      [e.target.name]: e.target.value,
    }));
  };

  const contactSchemaData = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: 'Contact GrhamDeal',
    url: 'https://grhamdeal.com/contact-us',
    description:
      'Contact GrhamDeal for rental property questions, listing support, account help and general inquiries.',
    mainEntity: {
      '@type': 'Organization',
      name: 'GrhamDeal',
      alternateName: 'Grham Deal',
      url: 'https://grhamdeal.com/',
      email: 'support@grhamdeal.com',
      parentOrganization: {
        '@type': 'Organization',
        name: 'Kaundal Ventures',
      },
    },
  };

  return (
    <>
      <SEO
        title="Contact GrhamDeal | Rental Property Support"
        description="Contact GrhamDeal for rental property questions, listing support, account help and general inquiries. Our support team is here to help tenants and property owners."
        canonical="https://grhamdeal.com/contact-us"
        image="https://grhamdeal.com/logo-512.png"
      />
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(contactSchemaData)}
        </script>
      </Helmet>
      <div className="contact-us bg-white">
        <div className="inner-banner">
          <div className="banner-content">
            <div className="container">
              <div className="row">
                <div className="col-12 animate__animated animate__fadeInDown">
                  <h1 className="border-img-one">Contact Us</h1>
                  <p>
                    Have questions about rental properties, listing your
                    property, your account, or using GrhamDeal? Our support team
                    is here to help.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoading && <Loader />}
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="box-view">
                  <div className="mb-4">
                    <h3 className="box-title text-uppercase fw-bold mb-2">
                      Send Us A Message
                    </h3>
                    <p className="text-muted small mb-0">
                      {/* Have questions about our properties, features, or pricing?
                    Drop us a line below. */}
                      <p>
                        Your message goes directly to the GrhamDeal support
                        team. We will get back to you as soon as possible.
                      </p>
                    </p>
                  </div>
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">
                        Name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        // placeholder="Your name"
                        name="name"
                        value={inputData.name}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Email<span className="required">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        // placeholder="Your email id"
                        name="email"
                        value={inputData.email}
                        onChange={handleChange}
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">
                        Message<span className="required">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        style={{ minHeight: '180px' }}
                        // placeholder="Your message"
                        name="message"
                        value={inputData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <button
                      disabled={isLoading}
                      type="submit"
                      className="btn btn-primary"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              </div>
              <div className="col-md-4">
                <div className="box-view">
                  <h3 className="box-title">Email Us</h3>
                  <p>
                    For rental property and general inquiries:
                    <br />
                    <a href="mailto:support@grhamdeal.com">
                      support@grhamdeal.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
